/**
 * Theme Configuration
 * Central theme configuration for Daily Dynamic Trading Co.
 */

import { extendTheme } from '@chakra-ui/react';
import { colors } from './palette';

export const theme = extendTheme({
  colors: {
    ...colors,
  },
  fonts: {
    heading: 'Inter, system-ui, sans-serif',
    body: 'Inter, system-ui, sans-serif',
  },
  styles: {
    global: {
      body: {
        bg: 'white',
        color: 'gray.800',
      },
    },
  },
});

export * from './palette';

